import type { RouteRecordRaw } from "vue-router";

const Dashboard = () => import("@/pages/account/innovadis/inno-dashboard.vue");
const Profile = () => import("@/pages/account/profile.vue");
const ChangePassword = () => import("@/pages/account/change-password.vue");
const Orders = () => import("@/pages/account/innovadis/inno-orders.vue");
const OrderDetails = () => import("@/pages/account/innovadis/inno-order-details.vue");
const DropOffPoint = () => import("@/pages/account/innovadis/inno-drop-off-point.vue");
const OrderPayment = () => import("@/pages/account/order-payment.vue");
const Backorders = () => import("@/pages/account/innovadis/inno-backorders.vue");
const Invoices = () => import("@/pages/account/innovadis/inno-invoices.vue");
const InvoiceDetails = () => import("@/pages/account/innovadis/inno-invoice-details.vue");
const AccountBulkOrder = () => import("@/pages/account/innovadis/inno-account-bulk-order.vue");
const Lists = () => import("@/pages/account/lists.vue");
const ListDetails = () => import("@/pages/account/innovadis/inno-list-details.vue");
const SavedCreditCards = () => import("@/pages/account/saved-credit-cards.vue");

export const accountRoutes: RouteRecordRaw[] = [
  { path: "dashboard", name: "Dashboard", component: Dashboard },
  { path: "change-password", name: "ChangePasswordAccount", component: ChangePassword },
  { path: "afzetpunt", name: "DropOffPoint", component: DropOffPoint },
  { path: "profile", name: "Profile", component: Profile },
  {
    path: "orders",
    children: [
      { path: "", name: "Orders", component: Orders },
      {
        path: ":orderId",
        children: [
          {
            path: "",
            name: "OrderDetails",
            component: OrderDetails,
            props: true,
          },
          {
            path: "payment",
            name: "OrderPayment",
            component: OrderPayment,
            props: true,
            meta: { layout: "Secure" },
          },
        ],
        meta: { hideLeftSidebar: true },
      },
    ],
  },
  {
    path: "backorders",
    children: [
      { path: "", name: "Backorders", component: Backorders },
      {
        path: ":orderId",
        children: [
          {
            path: "",
            name: "OrderDetails",
            component: OrderDetails,
            props: true,
          },
        ],
        meta: { hideLeftSidebar: true },
      },
    ],
  },
  {
    path: "invoices",
    children: [
      { path: "", name: "Invoices", component: Invoices },
      {
        path: ":invoiceId",
        children: [
          {
            path: "",
            name: "InvoiceDetails",
            component: InvoiceDetails,
            props: true,
          },
        ],
        meta: { hideLeftSidebar: true },
      },
    ],
  },
  {
    path: "lists",
    children: [
      { path: "", name: "Lists", component: Lists },
      {
        path: ":listId",
        name: "ListDetails",
        component: ListDetails,
        props: true,
      },
    ],
  },
  { path: "bulk-order", name: "AccountBulkOrder", component: AccountBulkOrder },
  {
    path: "saved-credit-cards",
    name: "SavedCreditCards",
    component: SavedCreditCards,
  },
];
